import {Payload} from '../../../services/payload/models/payload';

export class FavoriteFilter {
  filterName: string='';
  userName?: string;
  filter?:Payload = Payload.create(undefined,undefined);
  constructor(object?: any){
  }
}
